export class LogCompleto {
    Url: String;
    Controlador: String;
    Metodo: String;
    Descripcion: String;
    Accion: String;
    Tabla: String;
}
